import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Decimal from 'decimal.js';
import { QUANTITY } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import {
  notification, Checkbox,
} from 'antd';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { v4 as uuidv4 } from 'uuid';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import SoActions from '@Actions/sales/soActions';
import TenantActions from '@Actions/tenantActions';
import InvoiceActions from '@Actions/invoiceActions';
import FulfillmentLines from './FulfillmentLines.jsx';
import './style.scss';

const FulfillForm = ({
  user, fulfillUnfulfilledOrderLoading, selectedLocationFulfillment, soMapping, selectedSO, MONEY, fulfillUnfulfilledOrder, callback, orderId, match, getInvoiceByIdLoading,
}) => {
  const [data, setData] = useState([{
    key: uuidv4(), asset1: '', product_sku_name: '', quantity: '', unitPrice: '', lot: 0, taxId: '', discount: 0,
  }]);
  const [allStock, setAllStock] = useState(true);
  const [tenantDepartmentId, setTenantDepartmentId] = useState('');
  const [trackUrl, setTrackUrl] = useState('');
  const [trackCompany, setTrackCompany] = useState('');
  const [trackNumber, setTrackNumber] = useState('');
  const [message, setMessage] = useState('');
  const [notifyCustomer, setNotifyCustomer] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSellerChange, setIsSellerChange] = useState(false);

  const isMarketplaceEnabled = user?.tenant_info?.global_config?.settings?.marketplace_enabled;

const getBatches = (oldBatches, quantity, lineUomInfo, productUomInfo) => {
    const batches = oldBatches;
    let remainingQty = new Decimal(quantity);
    for (let i = 0; i < batches?.length; i++) {
      batches[i].consumed_qty = 0;
    }
    for (let i = 0; i < batches?.length; i++) {
      const availableQty = new Decimal(batches?.[i]?.available_qty || 0);
      const lineRatio = new Decimal(lineUomInfo?.ratio || 1);
      const productRatio = new Decimal(productUomInfo?.ratio || 1);
      const avlQty = availableQty.div(lineRatio).mul(productRatio);
      const consumedQty = new Decimal(batches[i]?.consumed_qty || 0);
      if (remainingQty.greaterThan(0) && consumedQty.lessThan(avlQty)) {
        const toConsume = Decimal.min(avlQty, remainingQty);
        batches[i].consumed_qty = toConsume.toNumber();
        batches[i].batch_in_use = true;
        remainingQty = remainingQty.minus(toConsume);
      } else {
        batches[i].consumed_qty = 0;
        batches[i].batch_in_use = true;
        remainingQty = remainingQty.minus(batches[i].consumed_qty);
      }
    }
    return batches;
  };

  function getAvailableQty(record, productBatches) {
    let availableQty = 0;
    if (record?.bundle_products?.length) {
      const arr = [];
      for (let i = 0; i < record?.bundle_products?.length; i++) {
        const bundleProductBatches = getBatches(record?.bundle_products?.[i]?.available_batches, Math.min(record?.bundle_products?.[i]?.quantity, Helpers.getValueTotalInObject(record?.bundle_products?.[i]?.available_batches, 'available_qty')), record?.bundle_products?.[i]?.uom_info?.[0], record?.bundle_products?.[i]?.product_sku_info?.uom_info);
        const qty = Helpers.getValueTotalInObject(bundleProductBatches?.filter((item) => item?.batch_in_use), 'available_qty');
        arr.push(qty / (record?.bundle_products[i]?.quantity / record?.quantity));
      }
      availableQty = Math.min(...arr);
    } else {
      availableQty = Helpers.getValueTotalInObject(productBatches?.filter((item) => item?.batch_in_use), 'available_qty');
    }
    return QUANTITY(availableQty, record?.uom_info?.[0]?.precision);
  }

  const convertFFLinesToNewFFLines = (oldData) => {
    for (const item of oldData) {
      if (item.seller_id === null) {
        item.seller_id = 'others';
        item.seller_name = 'others';
      }
    }

    const sellerFFLinesMapping = {};

    for (let i = 0; i < oldData.length; i++) {
      const item = oldData[i];
      const sellerId = item.seller_id;

      if (!sellerFFLinesMapping[sellerId]) {
        sellerFFLinesMapping[sellerId] = [];
      }

      sellerFFLinesMapping[sellerId].push(item);
    }

    const keys = Object.keys(sellerFFLinesMapping);
    const finalLines = [];
    for (let i = 0; i < keys?.length; i++) {
      const sellerId = keys[i];
      finalLines.push({
        sellerId,
        sellerName: sellerFFLinesMapping[sellerId][0]?.seller_name,
      });
      sellerFFLinesMapping[sellerId].map((ff_line) => finalLines.push(ff_line));
    }

    return finalLines;
  };

  useEffect(() => {
    if (selectedLocationFulfillment) {
      const fulfillmentLines = [];
      for (let i = 0; i < selectedLocationFulfillment?.fulfillment_lines?.length; i++) {
        const fulfillmentLine = selectedLocationFulfillment?.fulfillment_lines[i];
        const batches = getBatches(fulfillmentLine?.tenant_product_info?.all_product_batches, Math.min(fulfillmentLine?.quantity, Helpers.getValueTotalInObject(fulfillmentLine?.tenant_product_info?.all_product_batches, 'available_qty')), fulfillmentLine?.tenant_product_info?.product_sku_info?.purchase_uom_info, fulfillmentLine?.tenant_product_info?.product_sku_info?.uom_info);

        const parentKey = uuidv4();

        fulfillmentLines.push({
          key: parentKey,
          asset1: fulfillmentLine?.tenant_product_info?.product_sku_info?.assets?.[0]?.url || '',
          product_sku_name: fulfillmentLine?.tenant_product_info?.product_sku_info?.product_sku_name,
          tenant_id: selectedLocationFulfillment?.tenant_info?.tenant_id,
          fulfillable_quantity: fulfillmentLine?.fulfillable_quantity,
          so_quantity: fulfillmentLine?.quantity,
          quantity: ['NON_STORABLE', 'SERVICE', 'BUNDLE'].includes(fulfillmentLine?.tenant_product_info?.product_sku_info?.product_type) ? fulfillmentLine?.fulfillable_quantity : Math.min(fulfillmentLine?.fulfillable_quantity, getAvailableQty(fulfillmentLine, batches)),
          uom_info: fulfillmentLine?.tenant_product_info?.product_sku_info?.uom_info,
          fulfillment_line_id: fulfillmentLine?.fulfillment_line_id,
          shopify_fulfillment_order_line_id: fulfillmentLine?.shopify_fulfillment_order_line_id,
          shopify_fulfillment_order_id: selectedLocationFulfillment?.shopify_fulfillment_order_id,
          product_batches: batches,
          expiry_days: fulfillmentLine?.tenant_product_info?.product_sku_info?.expiry_days,
          product_sku_info: fulfillmentLine?.tenant_product_info?.product_sku_info,
          tenant_product_id: fulfillmentLine?.tenant_product_info?.tenant_product_id,
          unit_price: soMapping?.[`${fulfillmentLine?.tenant_product_info?.product_sku_info?.product_sku_id}`]?.[0]?.unit_price,
          tax_info: soMapping?.[`${fulfillmentLine?.tenant_product_info?.product_sku_info?.product_sku_id}`]?.[0]?.tax_info,
          is_marketplace_product: fulfillmentLine?.tenant_product_info?.product_sku_info?.is_marketplace_product,
          seller_id: fulfillmentLine?.tenant_product_info?.default_sku_offer?.seller_id || null,
          seller_name: fulfillmentLine?.tenant_product_info?.default_sku_offer?.seller_name || null,
          tenant_seller_id: fulfillmentLine?.tenant_product_info?.default_sku_offer?.tenant_seller_id || null,
          bundle_products: fulfillmentLine?.bundle_products?.map((item) => ({
            ...item,
            parentKey,
            key: uuidv4(),
            unitPrice: QUANTITY(item?.unit_price),
            uom_info: item?.tenant_product_info?.product_sku_info?.uom_info,
            product_sku_name: item?.tenant_product_info?.product_sku_info?.product_sku_name,
            so_quantity: item?.quantity,
            expiry_days: item?.tenant_product_info?.product_sku_info?.expiry_days,
            product_sku_info: item?.tenant_product_info?.product_sku_info,
            tenant_product_id: item?.tenant_product_info?.tenant_product_id,
            product_batches: getBatches(item?.tenant_product_info?.all_product_batches, Math.min(item?.quantity, Helpers.getValueTotalInObject(item?.tenant_product_info?.all_product_batches, 'available_qty')), item?.tenant_product_info?.product_sku_info?.purchase_uom_info, item?.tenant_product_info?.product_sku_info?.uom_info),
          })),
        });
      }
      if (isMarketplaceEnabled) {
        const refactoredData = convertFFLinesToNewFFLines(fulfillmentLines);
        setData(refactoredData || []);
      } else {
        setData(fulfillmentLines);
      }
      setTenantDepartmentId(selectedLocationFulfillment?.tenant_department_info?.tenant_department_id);
    }
  }, []);

  useEffect(() => {
    if (isSellerChange && isMarketplaceEnabled) {
      const copyData = JSON.parse(JSON.stringify(data))?.filter((item) => !item?.sellerId);
      const refactoredData = convertFFLinesToNewFFLines(copyData);
      setData(refactoredData || []);
      setIsSellerChange(false);
    }
  }, [isSellerChange]);

  const handleDelete = (key) => {
    if (data?.filter((item) => item?.seller_id)?.length === 1) {
      notification.error({
        message: 'Order line must have atleast one line',
        placement: 'top',
        duration: 4,
      });
    } else {
      const copyData = data.filter((item) => item.key !== key);
      setData(copyData);
      if (isMarketplaceEnabled) {
        setIsSellerChange(true);
      }
    }
  };

  function getLineTotals() {
    let totalBase = 0;
    let totalTax = 0;
    let totalAmount = 0;
    for (let i = 0; i < data?.length; i++) {
      let currentBase = 0;
      let currentTax = 0;
      let currentAmount = 0;
      if (data[i].quantity) currentBase += (data[i].quantity * data[i].unit_price) * (data[i].discount ? Number(100 - data[i].discount) / 100 : 1);
      if (data[i]?.tax_info?.[0]?.tax_value) currentTax += currentBase * (data?.[i]?.tax_info ? data[i]?.tax_info?.[0]?.tax_value / 100 : 0);
      if (currentBase) currentAmount = currentBase + currentTax;
      totalBase += currentBase;
      totalTax += currentTax;
      totalAmount += currentAmount;
    }
    return {
      totalBase,
      totalTax,
      totalAmount,
    };
  }

  function isDataValid() {
    const copyData = isMarketplaceEnabled ? data?.filter((item) => !item?.sellerId) : data;

    let isValid = true;
    for (let i = 0; i < copyData?.length; i++) {
      if (copyData[i]?.product_sku_info?.product_type === 'BUNDLE') {
        const arr = [];
        const bundleProducts = copyData[i]?.bundle_products?.filter((item) => !['SERVICE', 'NON_STORABLE']?.includes(item?.product_sku_info?.product_type));
        for (let j = 0; j < bundleProducts?.length; j++) {
          const bundleProductBatches = bundleProducts?.[j]?.product_batches;
          const qty = Helpers.getValueTotalInObject(bundleProductBatches?.filter((i) => i?.available_qty > 0)?.filter((item) => item?.batch_in_use), 'available_qty');
          arr.push(qty / (bundleProducts[j]?.quantity / copyData[i]?.quantity));
        }
        if (((Math.min(...arr) - Number(copyData[i]?.quantity || 0)) < 0) || Number(copyData[i].quantity) <= 0) {
          isValid = false;
        }
      } else if (copyData[i]?.product_sku_info?.product_type?.toUpperCase() === 'NON_STORABLE') {
        if (Number(copyData[i].quantity) <= 0 || !copyData[i].product_sku_name || (Number(copyData[i]?.quantity || 0) < 0)) {
          isValid = false;
        }
      } else if (Number(copyData[i].quantity) <= 0 || !copyData[i].product_sku_name || (copyData[i]?.product_sku_info?.product_type?.toUpperCase() !== 'SERVICE' ? Number(Number(Helpers.getValueTotalInObject(copyData[i]?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => item?.batch_in_use), 'available_qty') || 0) - Number(copyData[i]?.quantity || 0)) < 0 : false)) {
        isValid = false;
      }
    }
    return isValid;
  }

  function checkTrackInfo() {
    let hasTrackInfo = true;
    if (trackNumber) {
      if (!trackUrl || !trackCompany) {
        hasTrackInfo = false;
      } else if (trackUrl && !Helpers.isValidUrl(trackUrl)) {
        hasTrackInfo = false;
      }
    }
    return hasTrackInfo;
  }

  function fulfillOrder() {
    const copyData = isMarketplaceEnabled ? data?.filter((item) => !item?.sellerId) : data;

    const orderLines = [];
    const getOrderLineBatches = (batches) => {
      const orderBatches = [];
      for (let j = 0; j < batches?.length; j++) {
        if (batches[j]?.batch_in_use && batches[j]?.consumed_qty > 0) {
          orderBatches.push({
            batch_id: batches[j]?.batch_id,
            quantity: batches[j]?.consumed_qty,
            is_rejected_batch: batches[j]?.is_rejected_batch,
          });
        }
      }
      return orderBatches;
    };
    setFormSubmitted(true);
    if (isDataValid() && checkTrackInfo()) {
      if (isMarketplaceEnabled) {
        for (let i = 0; i < copyData?.length; i++) {
          const orderLine = {
            tenant_id: copyData[i]?.tenant_id,
            seller_id: copyData[i]?.seller_id,
            fulfillable_quantity: copyData[i]?.fulfillable_quantity,
            shopify_fulfillment_order_line_id: copyData[i].shopify_fulfillment_order_line_id,
            quantity: Number(copyData[i].quantity),
            sku_id: copyData[i]?.product_sku_info?.product_sku_id,
            product_batches: copyData[i]?.product_sku_info?.product_type === 'STORABLE' ? getOrderLineBatches(copyData?.[i]?.product_batches) : [],
            bundle_products: copyData[i]?.bundle_products?.map((item) => ({
              tenant_id: copyData[i]?.tenant_id,
              tenant_product_id: item.tenant_product_id,
              order_line_id: item.order_line_id,
              offer_price: Number(item.unitPrice || 0),
              unit_price: Number(item.unitPrice || 0),
              tax_id: item?.taxInfo?.tax_id,
              tax_info: [item?.taxInfo],
              uom_info: [item?.uom_info],
              fulfillable_quantity: copyData[i]?.fulfillable_quantity,
              quantity: Number(copyData[i]?.quantity * item?.bundle_quantity),
              product_sku_id: item.product_sku_info.product_sku_id,
              product_sku_name: item.product_sku_name,
              uom_id: item?.uomId,
              discount_percent: Number(item?.discount || 0),
              product_batches: getOrderLineBatches(item?.product_batches),
            })),
          };
          orderLines.push(orderLine);
        }

        const payload = [];

        for (let i = 0; i < copyData?.length; i++) {
          const ffLineLineObj = {
            seller_id: copyData[i]?.seller_id !== 'other' ? copyData[i]?.seller_id : null,
            is_marketplace_fulfillment: copyData[i]?.seller_id !== 'others',
            message: message || '',
            notify_customer: notifyCustomer,
            shopify_fulfillment_order_id: selectedLocationFulfillment?.shopify_fulfillment_order_id,
            fulfillment_lines: orderLines?.filter((item) => item?.seller_id === copyData[i]?.seller_id),
            order_id: orderId,
            tracking_info: {
              number: trackNumber,
              company: trackCompany,
              url: trackUrl,
            },
          };
          payload.push(ffLineLineObj);
        }

        const uniquePayload = [];
        const uniqueSellerIds = new Set();

        payload.forEach((item) => {
          if (!uniqueSellerIds.has(item.seller_id)) {
            uniqueSellerIds.add(item.seller_id);
            uniquePayload.push(item);
          }
        });
        fulfillUnfulfilledOrder(uniquePayload, () => {
          callback();
        });
      } else {
        for (let i = 0; i < copyData?.length; i++) {
          const orderLine = {
            tenant_id: copyData[i]?.tenant_id,
            fulfillable_quantity: copyData[i]?.fulfillable_quantity,
            shopify_fulfillment_order_line_id: copyData[i].shopify_fulfillment_order_line_id,
            quantity: Number(copyData[i].quantity),
            sku_id: copyData[i]?.product_sku_info?.product_sku_id,
            product_batches: copyData[i]?.product_sku_info?.product_type === 'STORABLE' ? getOrderLineBatches(copyData?.[i]?.product_batches) : [],
            bundle_products: copyData[i]?.bundle_products?.map((item) => ({
              tenant_id: copyData[i]?.tenant_id,
              tenant_product_id: item.tenant_product_id,
              order_line_id: item.order_line_id,
              offer_price: Number(item.unitPrice || 0),
              unit_price: Number(item.unitPrice || 0),
              tax_id: item?.taxInfo?.tax_id,
              tax_info: [item?.taxInfo],
              uom_info: [item?.uom_info],
              fulfillable_quantity: copyData[i]?.fulfillable_quantity,
              quantity: Number(copyData[i]?.quantity * item?.bundle_quantity),
              product_sku_id: item.product_sku_info.product_sku_id,
              product_sku_name: item.product_sku_name,
              uom_id: item?.uomId,
              discount_percent: Number(item?.discount || 0),
              product_batches: getOrderLineBatches(item?.product_batches),
            })),
          };
          orderLines.push(orderLine);
        }
        const payload = [{
          message: message || '',
          notify_customer: notifyCustomer,
          shopify_fulfillment_order_id: selectedLocationFulfillment?.shopify_fulfillment_order_id,
          fulfillment_lines: orderLines,
          order_id: orderId,
          tracking_info: {
            number: trackNumber,
            company: trackCompany,
            url: trackUrl,
          },
        }];

        fulfillUnfulfilledOrder(payload, () => {
          callback();
        });
      }
    }
  }

  function toggleBatch(record, adjustmentRow) {
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData?.length; i++) {
      if (copyData[i]?.key === adjustmentRow?.key) {
        const rowBatches = copyData[i]?.product_batches;
        for (let j = 0; j < rowBatches?.length; j++) {
          if (rowBatches[j]?.batch_id === record?.batch_id) {
            rowBatches[j].batch_in_use = !rowBatches[j]?.batch_in_use;
            copyData[i].quantity -= rowBatches[j].consumed_qty;
            rowBatches[j].consumed_qty = 0;
          }
        }
        break;
      }
    }
    setData(copyData);
  }

  function toggleBatchInner(record, adjustmentRow) {
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData?.length; i++) {
      const newData = copyData[i];
      if (newData?.key === adjustmentRow?.parentKey) {
        const bundleProducts = newData?.bundle_products;
        for (let j = 0; j < bundleProducts?.length; j++) {
          if (bundleProducts[j]?.key === adjustmentRow?.key) {
            const rowBatches = bundleProducts[j]?.product_batches;
            for (let k = 0; k < rowBatches?.length; k++) {
              if (rowBatches[k]?.batch_id === record?.batch_id) {
                rowBatches[k].batch_in_use = !rowBatches[k]?.batch_in_use;
                bundleProducts[j].quantity -= rowBatches[k].consumed_qty;
                rowBatches[k].consumed_qty = 0;
              }
            }
            break;
          }
        }
      }
    }
    setData(copyData);
  }

  function getDataSource() {
    const newData = JSON.parse(JSON.stringify(data));
    return newData;
  }

  return (
    <Fragment>
      {getInvoiceByIdLoading ? (
        <div className="fulfill__loading__wrapper">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
            <div key={item} className="fulfill__loading__wrapper-row">
              <div className="fulfill__loading__wrapper-row__label loadingBlock" />
              <div className="fulfill__loading__wrapper-row__value loadingBlock" />
            </div>
          ))}
          <div className="fulfill__loading__wrapper-table loadingBlock" />
          <div className="fulfill__loading__wrapper-details loadingBlock" />

        </div>
      )
        : (
          <div className={match.url.includes('/sales-order') ? 'fulfill__wrapper fulfill-component' : 'fulfill__wrapper fulfill-page'}>
            <div className="ant-row">
              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="SO#" className="fulfill__input-row__label" />
                  <div style={{ marginTop: '5px', fontSize: '13px', fontWeight: '500' }}>
                    {selectedSO?.sales_order_number}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" />
              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="Shopify Order#" className="fulfill__input-row__label" />
                  <div style={{ marginTop: '5px', fontSize: '13px', fontWeight: '500' }} className="fulfill__input-row__input">
                    {selectedSO?.shopify_order_number}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" />
              <div className="ant-col-md-24">
                <div className="fulfill__input-row" style={{ marginBottom: '10px' }}>
                  <H3Text text="Location" className="fulfill__input-row__label" />
                  <div style={{ marginTop: '5px', fontSize: '13px', fontWeight: '500' }} className="fulfill__input-row__input">
                    {`${selectedLocationFulfillment?.tenant_info?.tenant_name} (${selectedLocationFulfillment?.shopify_integration_details?.locations?.filter((item) => item?.id === Number(selectedLocationFulfillment?.assigned_shopify_location_id))[0]?.name})`}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="Tracking Number" className="fulfill__input-row__label" />
                  <H3FormInput
                    name="track number"
                    type="text"
                    containerClassName="orgInputContainer fulfill__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => setTrackNumber(e.target.value)}
                    value={trackNumber}
                    disabled={fulfillUnfulfilledOrderLoading}
                  />
                </div>
              </div>
              <div className="ant-col-md-12" />
              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="Shipping Carrier" className="fulfill__input-row__label" />
                  <H3FormInput
                    name="track company"
                    type="text"
                    containerClassName="orgInputContainer fulfill__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => setTrackCompany(e.target.value)}
                    value={trackCompany}
                    disabled={fulfillUnfulfilledOrderLoading || !trackNumber}
                  />
                </div>
                {formSubmitted && trackNumber && !trackCompany && <div className="input-error" style={{ marginBottom: (formSubmitted && trackNumber && !trackCompany) ? '10px' : '0px', marginLeft: '180px', marginTop: '-10px' }}>*Please enter shipping carrier</div>}
              </div>
              <div className="ant-col-md-12" />
              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="Tracking URL" className="fulfill__input-row__label" />
                  <H3FormInput
                    name="track url"
                    type="text"
                    containerClassName="orgInputContainer fulfill__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => setTrackUrl(e.target.value)}
                    value={trackUrl}
                    disabled={fulfillUnfulfilledOrderLoading || !trackNumber || !trackCompany}
                  />
                </div>
                {formSubmitted && (trackNumber || trackCompany) && (!trackUrl || !Helpers.isValidUrl(trackUrl)) && <div className="input-error" style={{ marginBottom: (formSubmitted && (trackNumber || trackCompany) && (!trackUrl || !Helpers.isValidUrl(trackUrl))) ? '10px' : '0px', marginLeft: '180px', marginTop: '-10px' }}>*Please enter a valid tracking URL</div>}
              </div>
              <div className="ant-col-md-12" />
              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="Notify customer" className="fulfill__input-row__label" />
                  <div style={{ marginTop: '5px' }}>
                    <Checkbox
                      disabled={fulfillUnfulfilledOrderLoading}
                      checked={notifyCustomer}
                      onChange={(event) => {
                        setNotifyCustomer(event.target.checked);
                      }}
                    />
                    <span style={{ fontWeight: '500', fontSize: '12px', marginLeft: '5px' }}>
                      Send shipment details to your customer now
                    </span>
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" />
            </div>
            <div className="fulfill__lines-wrapper">
              <FulfillmentLines
                isMarketplaceEnabled={isMarketplaceEnabled}
                handleDelete={handleDelete}
                data={getDataSource()}
                updateData={(updatedData) => setData(updatedData)}
                formSubmitted={formSubmitted}
                loading={fulfillUnfulfilledOrderLoading}
                tenantDepartmentId={tenantDepartmentId}
                toggleBatch={(batch, adjustmentRow) => toggleBatch(batch, adjustmentRow)}
                toggleBatchInner={(batch, adjustmentRow) => toggleBatchInner(batch, adjustmentRow)}
                selectedLocationFulfillment={selectedLocationFulfillment}
                soMapping={soMapping}
                allStock={allStock}
                toggleAllStock={() => setAllStock(!allStock)}
                setIsSellerChange={(boolValue) => setIsSellerChange(boolValue)}
              />
              <div className="fulfill__summary-wrapper">
                <div>
                  <div className="text-area__po-container">
                    <label className="orgFormLabel">
                      Message
                    </label>
                    <textarea
                      className="orgFormInput text-area__po"
                      rows="2"
                      cols="50"
                      onChange={(event) => {
                        setMessage(event.target.value);
                      }}
                      disabled={fulfillUnfulfilledOrderLoading}
                      value={message}
                    />
                  </div>
                </div>
                <div className="fulfill__summary">
                  <div className="quote-conf__field">
                    <H3Text text="Taxable Amount" className="quote-conf__field-name" />
                    <H3Text text={MONEY(getLineTotals().totalBase)} className="quote-conf__field-value" />
                  </div>
                  <div className="quote-conf__field">
                    <H3Text text="Tax" className="quote-conf__field-name" />
                    <H3Text text={MONEY(getLineTotals().totalTax)} className="quote-conf__field-value" />
                  </div>
                  <div className="quote-conf__field quote-conf__field-total">
                    <H3Text text="Total Amount" className="quote-conf__field-name" />
                    <H3Text text={MONEY(getLineTotals().totalAmount)} className="quote-conf__field-value" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      <div className="fulfill__footer">
        <H3Button
          text="Save and Issue"
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          customClass="fulfill__footer-submit"
          onClick={() => {
            fulfillOrder();
          }}
          isLoading={fulfillUnfulfilledOrderLoading}
          disabled={fulfillUnfulfilledOrderLoading}
        />
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  SellerReducers, UserReducers, ProductReducers, SOReducers, TenantReducers, InvoiceReducers,
}) => ({
  MONEY: UserReducers.MONEY,
  sellers: SellerReducers.sellers,
  products: ProductReducers.products,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  user: UserReducers.user,
  selectedInvoice: InvoiceReducers.selectedInvoice,
  fulfillUnfulfilledOrderLoading: SOReducers.fulfillUnfulfilledOrderLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updatePoStatus: (payload, callback) => dispatch(PurchaseOrderActions.updatePoStatus(payload, callback)),
  getTenantsConfiguration: (tenantId, callback) => dispatch(TenantActions.getTenantsConfiguration(tenantId, callback)),
  getInvoiceById: (tenantId, invoiceId) => dispatch(InvoiceActions.getInvoiceById(tenantId, invoiceId)),
  updateInvoice: (payload, callback) => dispatch(InvoiceActions.updateInvoice(payload, callback)),
  fulfillUnfulfilledOrder: (payload, callback) => dispatch(SoActions.fulfillUnfulfilledOrder(payload, callback)),
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FulfillForm));
